export default __webpack_public_path__ + "static/media/spirehub-logo.99562e5f.webp";